// extracted by mini-css-extract-plugin
module.exports = {"heading":"RentalAgreementPage_heading__2C2G_","content":"RentalAgreementPage_content__2RonK"};